import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";

export function Modal({
  open = true,
  size = "md",
  zIndex = 100,
  children,
  onClose,
}: {
  open?: boolean;
  size?: "xs" | "sm" | "md" | "lg";
  zIndex?: number;
  children: React.ReactNode;
  onClose?: () => void;
}) {
  useEffect(() => {
    let handleEsc: (event: KeyboardEvent) => void;
    if (onClose) {
      // Listen to esc key
      handleEsc = (event: KeyboardEvent) => {
        if (event.key === "Escape") {
          onClose();
        }
      };
      window.addEventListener("keydown", handleEsc);
    }
    return () => {
      if (handleEsc) {
        window.removeEventListener("keydown", handleEsc);
      }
    };
  });

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  if (!open) {
    return null;
  }

  let sizeClasses = "";
  if (size === "xs") {
    sizeClasses = "sm:min-h-auto sm:min-w-[30%] lg:min-w-[20%] xl:min-w-[15%]";
  } else if (size === "sm") {
    sizeClasses = "sm:min-h-[50%] sm:min-w-[50%] lg:min-w-[40%] xl:min-w-[35%]";
  } else if (size === "md") {
    sizeClasses = "sm:min-h-[75%] sm:min-w-[70%] lg:min-w-[50%]";
  } else if (size === "lg") {
    sizeClasses = "sm:min-h-[90%] sm:min-w-[90%] lg:min-w-[80%]";
  }

  return (
    <div
      className="fixed inset-0 bg-black/50 flex justify-center items-center"
      style={{ zIndex }}
    >
      <div
        className={`bg-white rounded-md px-4 pt-8 pb-4 relative max-h-full overflow-y-scroll min-h-[95%] min-w-[95%] ${sizeClasses} flex flex-col`}
      >
        <FontAwesomeIcon
          className="absolute top-2 right-2 cursor-pointer"
          icon={faTimes}
          onClick={() => {
            onClose?.();
          }}
        />
        {children}
      </div>
    </div>
  );
}
